import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BatteryCharging } from 'lucide-react';
import api from '../utils/api';
import UpsCard from './UpsCard';
import CompanyLogo from './CompanyLogo';

// Self-populating UPS strip for the internal agent Dashboard. Uses the
// company-scoped /api/ups, so a scoped agent (e.g. Ezequiel/Beto → Papelera)
// sees only their companies' UPS, admins see all, and it renders nothing when
// there's no UPS in scope. Clicking a card jumps to Monitor → UPS tab.
export default function UpsDashboardStrip() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = () => api.get('/ups')
      .then(({ data }) => { if (!cancelled) setList(Array.isArray(data) ? data : []); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setReady(true); });
    load();
    const iv = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(iv); };
  }, []);

  if (!ready || !list.length) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <BatteryCharging size={15} style={{ color: 'var(--c-brand)' }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--c-text-muted)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
          {t('ups.sectionTitle')}
        </span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 12 }}>
        {list.map((u) => (
          <div key={u.id}>
            {u.company_name && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6, fontSize: 12, color: 'var(--c-text-muted)' }}>
                <CompanyLogo name={u.company_name} logoUrl={u.company_logo} size={16} /> {u.company_name}
              </div>
            )}
            <UpsCard ups={u} compact onClick={() => navigate('/monitor?tab=ups')} />
          </div>
        ))}
      </div>
    </div>
  );
}
